/*统一推荐的附件数据*/
import {apiRequest} from "@/api/api";

//----------------------------------------------统一推荐的附件数据
/*文件上传之后,提交文件信息*/
export function uploadFiles(config) {
   config.method = 'post'
   config.formData = true
   config.url = '/project/PaUploadedFile/uploadFiles'
   apiRequest(config)
}

/*获取统一推荐的文件列表*/
export function getUploadFiles(config) {
   config.method = 'get'
   config.url = '/project/PaUploadedFile/getUploadFiles'
   apiRequest(config)
}

/*通过路径删除已上传的文件*/
export function deleteUploadFiles(config) {
   config.method = 'post'
   config.formData = true
   config.url = '/project/PaUploadedFile/deleteByPath'
   apiRequest(config)
}